import When from "../../../components/When";
import {IDocumentModule} from "../../../core/interfaces/document";
import getIcon, {Icon, IconSize} from "../../../assets/Icons/IconClassNames";
import {useDocumentModulesContext} from "./DocumentModules";
import ClickableIconButton from "../../../components/ClickableIconButton/ClickableIconButton";
import React, {useState} from "react";
import SimpleConfirmModal from "../../../components/ModalComponents/SimpleConfirmModal";
import useAccessCheck from "../../../hooks/useAccessCheck";
import {ChecklistView, ModuleType, TemplateType} from "../../../core/enums/enums";
import SaveAsTemplate from "../Components/Templates/SaveAsTemplate";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";

interface IDocumentModulesActionButtons {
    index: number;
    isActiveModule: boolean;
    module: IDocumentModule;
    children: any;
}

const DocumentModulesActionButtons = (
    {
        index,
        isActiveModule,
        module,
        children,
    }: IDocumentModulesActionButtons) => {

    const {
        activeModule,
        isEditMode,
        setActiveModule,
        cancelEditModule,
        saveChanges,
        deleteModule,
        isNoChangesActiveModule,
        isSaveDisabled,
        updateChecklistView,
    } = useDocumentModulesContext();

    const [, checkRole] = useAccessCheck();
    const [showDeleteChecklistModal, setShowDeleteChecklistModal] = useState(false);
    const [showSaveChecklistTemplateModal, setShowSaveChecklistTemplateModal] = useState(false);

    const saveCancelButtons = () => (
        <div className="d-flex align-content-end flex-row-reverse">
            <ClickableIconButton
                disabled={false}
                buttonType={"CANCEL"}
                icon={getIcon(Icon.X_MARK, IconSize.XL)}
                onClick={cancelEditModule}
                title={"Avbryt redigering"}
            />
            <ClickableIconButton
                disabled={isNoChangesActiveModule || isSaveDisabled}
                buttonType={"SAVE"}
                icon={getIcon(Icon.SAVE, IconSize.XL)}
                title={"Spara ändringar"}
                onClick={saveChanges}
            />
        </div>
    );

    const editDeleteButtons = () => (
        <div className="d-flex align-content-end flex-row-reverse">
            <ClickableIconButton
                disabled={false}
                buttonType={"CANCEL"}
                icon={getIcon(Icon.REMOVE, IconSize.XL)}
                onClick={() => setShowDeleteChecklistModal(true)}
                title={"Radera modul"}
            />
            <ClickableIconButton
                disabled={false}
                buttonType={"EDIT"}
                icon={getIcon(Icon.EDIT, IconSize.XL)}
                onClick={() => setActiveModule(module, index)}
                title={"Redigera modul"}
            />
        </div>
    );

    const handleDeleteModule = () => {
        deleteModule(module.id);
        setShowDeleteChecklistModal(false);
    }

    const moduleType = (type: string) => {
        switch (type) {
            case ModuleType.TEXT:
                return {if: "textmodul", df: "textmodulen"}

            case ModuleType.CHECKLIST:
                return {if: "checklista", df: "checklistan"}
        }
    }

    return <>
        <Row className={"pb-3"}>
            <When condition={!!module.documentModuleChecklist}>
                <Col className="d-flex">
                    <ClickableIconButton
                        disabled={false}
                        buttonType={"EDIT"}
                        title={"Tabellvy"}
                        icon={getIcon(Icon.TABLE, IconSize.XL)}
                        onClick={() => updateChecklistView(module.id, ChecklistView.TABLE)}
                    />
                    <ClickableIconButton
                        disabled={false}
                        buttonType={"EDIT"}
                        title={"Listvy"}
                        icon={getIcon(Icon.BARS, IconSize.XL)}
                        onClick={() => updateChecklistView(module.id, ChecklistView.LIST)}
                    />
                </Col>
            </When>
            <Col>
                <When condition={isEditMode}>
                    <When
                        condition={activeModule !== null}
                        otherwise={editDeleteButtons()}>
                        <When condition={isActiveModule} then={saveCancelButtons()}/>
                    </When>
                </When>
            </Col>
        </Row>
        <Row>
            <Col>
                {children}
            </Col>
        </Row>

        <SimpleConfirmModal
            show={showDeleteChecklistModal}
            header={<>Radera {moduleType(module?.documentModuleType)?.if}</>}
            text={<>Är du säker på att du vill radera {moduleType(module?.documentModuleType)?.df}
                <i>{module?.documentModuleChecklist?.header}</i>?<br/>Detta val går inte att ångra.</>}
            onClickOKText={"Ja, Radera"}
            onClickOK={handleDeleteModule}
            onClickCancelText={"NEJ"}
            onClickCancel={() => setShowDeleteChecklistModal(false)}
        />

        {showSaveChecklistTemplateModal && (
            <SaveAsTemplate
                showModal={showSaveChecklistTemplateModal}
                setShowModal={() => setShowSaveChecklistTemplateModal(false)}
                templateType={TemplateType.CHECKLIST}
                moduleId={module.id}
            />
        )}
    </>
};

export default DocumentModulesActionButtons;